import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable, of } from 'rxjs';
import { AuthService } from './services/auth/auth.service';
import { AuthorisationService } from './services/auth/authorisation.service';
import { Functionalities } from './services/auth/functionalities';
import { ConfirmDialogService } from './services/confirm-dialog-service/confirm-dialog.service';
import { LocalStorage } from './storage.class';

@Injectable()
export class IsAuthenticated {
    constructor(
        private router: Router,
        private confirmDialog: ConfirmDialogService,
        private authService: AuthService
    ) {}

    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        return new Promise((resolve, reject) => {
            const params = route.queryParams as { token: string };
            const routeData = route.data as RouteData;
            if (params.token) {
                LocalStorage.setUserToken(params.token);
            }
            if (LocalStorage.getUserToken()) {
                const userDetail$ = LocalStorage.getUser() ? of(null) : this.authService.getUserDetails();
                userDetail$.subscribe(() => {
                    resolve(this.checkRights(routeData));
                });
            } else {
                this.router.navigate(['login']);
                reject();
            }
        });
    }

    checkRights(routeData: RouteData): boolean {
        if (routeData.requiredFunctionality) {
            const hasFunctionality = AuthorisationService.hasAnyFunctionality(routeData.requiredFunctionality);
            if (!hasFunctionality) {
                this.confirmDialog
                    .confirm({
                        title: 'Geen rechten op deze functionaliteit',
                        text: `Je hebt geen rechten op de functionaliteit <b>${routeData.requiredFunctionality}</b>.`,
                        confirm: 'Sluiten',
                        cancel: null,
                    })
                    .then(
                        () => {},
                        () => {}
                    );
            }
            return hasFunctionality;
        }
        return true;
    }
}

type RouteData = {
    requiredFunctionality: Functionalities | Functionalities[];
};
